import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4aea8c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-update" }
const _hoisted_2 = { class: "page-container py-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus ml-3" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CollectionActionsHeader = _resolveComponent("CollectionActionsHeader")!
  const _component_CollectionHorizontalArtwork = _resolveComponent("CollectionHorizontalArtwork")!
  const _component_CollectionHorizontalList = _resolveComponent("CollectionHorizontalList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CollectionActionsHeader, {
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
      class: "py-6"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("collection.add-to-my-collections")), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CollectionHorizontalArtwork, {
        class: "mb-5",
        artwork: _ctx.artwork
      }, null, 8, ["artwork"]),
      _createVNode(_component_CollectionHorizontalList, {
        onAdd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add($event))),
        loading: _ctx.loading,
        class: "mb-5",
        entities: _ctx.entities
      }, null, 8, ["loading", "entities"]),
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.open())),
        class: "form-outline px-5"
      }, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("collection.add-to-new-collection")), 1),
        _hoisted_3
      ])
    ])
  ]))
}